module.exports = __webpack_public_path__ + "static/badge-7716c49754d6877da3f798bc3dd8e23a.svg";